module.exports = __webpack_public_path__ + "static/img/about.d846692.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about.jpeg
// module id = Zhyv
// module chunks = 23